export interface BookingSettings {
  bookingMode: 'instant' | 'request' | 'enquiry';
  minAdvanceTime: number;
  maxAdvanceTime: number;
  instantConfirmation: boolean;
  maxGroupSize: number;
}

export interface CancellationPolicy {
  timeLimit: number;
  refundPercentage: number;
}

export interface NotificationPreferences {
  email: boolean;
  sms: boolean;
  pushNotifications: boolean;
}

export interface BusinessSettings {
  cancellationPolicy: CancellationPolicy;
  bookingSettings: BookingSettings;
  notificationPreferences: NotificationPreferences;
}

// Default settings that can be used when initializing a new business
export const DEFAULT_BUSINESS_SETTINGS: BusinessSettings = {
  cancellationPolicy: {
    timeLimit: 24,
    refundPercentage: 80
  },
  bookingSettings: {
    bookingMode: 'instant',
    minAdvanceTime: 24,
    maxAdvanceTime: 90,
    instantConfirmation: true,
    maxGroupSize: 10
  },
  notificationPreferences: {
    email: true,
    sms: false,
    pushNotifications: false
  }
}; 